import { make } from 'vuex-pathify';
import { ExternalParticipantsSettingsService } from '@/modules/global-settings/delinquency/services/external-participants-settings.service';
import Logger from '@/lib/logger.js';

const service = new ExternalParticipantsSettingsService();

export const state = {
  externalParticipantsSettings: []
};

export const mutations = {
  ...make.mutations(state)
};

export const getters = {
  ...make.getters(state)
};

export const actions = {
  async getSettings({ commit }, payload) {
    try {
      const { data } = await service.getSettings(payload?.page, payload?.limit, payload?.type, payload?.name);
      commit('SET_EXTERNAL_PARTICIPANTS_SETTINGS', data.persons);
      return data;
    } catch (error) {
      Logger.error('Getting External Participants Settings');
      throw error;
    }
  },
  async createSetting(_, payload) {
    try {
      const { data } = await service.createSetting(payload);
      return data;
    } catch (error) {
      Logger.error('Creating External Participants Settings');
      throw error;
    }
  },
  async updateSetting(_, { id, payload }) {
    try {
      const { data } = await service.updateSetting({ id, payload });
      return data;
    } catch (error) {
      Logger.error('Updating External Participants Settings');
      throw error;
    }
  },
  async removeSetting(_, id) {
    try {
      const { data } = await service.removeSetting(id);
      return data;
    } catch (error) {
      Logger.error('Removing External Participants Settings');
      throw error;
    }
  },
  async setAllActiveStatus(_, { isActive }) {
    try {
      const { data } = await service.setAllActiveStatus({ isActive });
      return data;
    } catch (error) {
      Logger.error('Setting External Participants Settings Active Status');
      throw error;
    }
  }
};
